<template>
  <div class="filter-section mb-4">
    <!-- 첫 번째 줄: 주요 필터 -->
    <a-row :gutter="16" align="middle" class="filter-row">
      <a-col :span="5">
        <label class="filter-label">발송 상태</label>
        <a-select
          v-model:value="searchParams.status"
          placeholder="전체"
          style="width: 100%"
          allow-clear
        >
          <a-select-option
            v-for="option in statusOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </a-select-option>
        </a-select>
      </a-col>

      <a-col :span="6">
        <label class="filter-label">휴대폰 번호</label>
        <a-input
          v-model:value="searchParams.mobile"
          placeholder="010-0000-0000"
          @keyup.enter="handleSearch"
        />
      </a-col>

      <a-col :span="6">
        <label class="filter-label">템플릿 코드</label>
        <a-input
          v-model:value="searchParams.templateCode"
          placeholder="템플릿 코드 입력"
          @keyup.enter="handleSearch"
        />
      </a-col>

      <a-col :span="7" style="text-align: right;">
        <label class="filter-label">&nbsp;</label>
        <a-space>
          <a-button @click="handleReset">초기화</a-button>
          <a-button 
            type="primary" 
            @click="handleSearch"
            style="background-color: #FFD700; border-color: #FFD700; color: #000"
          >
            <i class="fa fa-search"></i> 검색
          </a-button>
        </a-space>
      </a-col>
    </a-row>

    <!-- 두 번째 줄: 날짜 필터 -->
    <a-row :gutter="16" align="middle" class="filter-row mt-3">
      <a-col :span="12">
        <label class="filter-label">조회 기간</label>
        <a-range-picker
          v-model:value="dateRange"
          :format="dateFormat"
          :placeholder="['시작일', '종료일']"
          style="width: 100%"
          @change="handleDateChange"
        />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { ref, reactive } from 'vue';
import dayjs from 'dayjs';
import { STATUS_OPTIONS } from '../alimtalkApi';

export default {
  name: 'AlimtalkSearchFilter',
  emits: ['search'],
  setup(props, { emit }) {
    const dateFormat = 'YYYY-MM-DD';
    const searchForm = ref(null);
    const dateRange = ref([]);
    
    const searchParams = reactive({
      status: '',
      mobile: '',
      templateCode: '',
      startDate: '',
      endDate: ''
    });

    const statusOptions = STATUS_OPTIONS;

    const handleDateChange = (dates) => {
      if (dates && dates.length === 2) {
        searchParams.startDate = dates[0].format('YYYY-MM-DD');
        searchParams.endDate = dates[1].format('YYYY-MM-DD');
      } else {
        searchParams.startDate = '';
        searchParams.endDate = '';
      }
    };

    const handleSearch = () => {
      const params = { ...searchParams };
      
      // 빈 값 제거
      Object.keys(params).forEach(key => {
        if (!params[key]) {
          delete params[key];
        }
      });

      // 휴대폰 번호 포맷 정리 (하이픈 제거)
      if (params.mobile) {
        params.mobile = params.mobile.replace(/-/g, '');
      }

      emit('search', params);
    };

    const handleReset = () => {
      searchParams.status = '';
      searchParams.mobile = '';
      searchParams.templateCode = '';
      searchParams.startDate = '';
      searchParams.endDate = '';
      dateRange.value = [];
      emit('search', {});
    };

    // 초기 검색 - 최근 7일
    const initSearch = () => {
      const today = dayjs();
      const weekAgo = dayjs().subtract(7, 'days');
      dateRange.value = [weekAgo, today];
      searchParams.startDate = weekAgo.format('YYYY-MM-DD');
      searchParams.endDate = today.format('YYYY-MM-DD');
      handleSearch();
    };

    return {
      searchForm,
      searchParams,
      dateRange,
      dateFormat,
      statusOptions,
      handleDateChange,
      handleSearch,
      handleReset,
      initSearch
    };
  },
  mounted() {
    this.initSearch();
  }
};
</script>

<style scoped>
.filter-section {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.filter-row {
  margin-bottom: 0;
}

.filter-label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #495057;
}

.help-icon {
  margin-left: 4px;
  color: #999;
  font-size: 12px;
  cursor: help;
}

.mt-3 {
  margin-top: 16px;
}

.mb-4 {
  margin-bottom: 24px;
}

/* 버튼 스타일 */
:deep(.ant-btn) {
  height: 32px;
}

:deep(.ant-input) {
  height: 32px;
}

:deep(.ant-select-selector) {
  height: 32px !important;
}

:deep(.ant-picker) {
  height: 32px;
}</style>